import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import React from 'react';

import { AccessPointData, PermissionData } from '../../api/types';
import { AccessPointMissingPermissionItem } from './AccessPointMissingPermissionItem';

interface AccessPointPermissionsProps {
    accessInformation: AccessPointData;
    missingPermissions: PermissionData[];
    translations: Record<string, string>;
}

export const AccessPointPermissions: React.FC<AccessPointPermissionsProps> = ({
    accessInformation,
    missingPermissions,
    translations,
}) => {
    if (!missingPermissions.length) {
        return (
            <Typography variant={'subtitle1'} fontWeight={600} textAlign={'center'}>
                {translations.ACCESS_POINT_NO_PERMISSION_APPLIED_TITLE}
            </Typography>
        );
    }

    return (
        <>
            <Typography variant={'subtitle1'} fontWeight={600} gutterBottom>
                {translations.ACCESS_POINT_MISSING_PERMISSIONS_TITLE}
            </Typography>
            <Typography variant={'subtitle2'} color="textSecondary" gutterBottom>
                {translations.ACCESS_POINT_MISSING_PERMISSIONS_SUBTITLE}
            </Typography>
            <List>
                {missingPermissions.map((permission) => (
                    <AccessPointMissingPermissionItem
                        accessPointCode={accessInformation.accessPointCode}
                        permission={permission}
                        translations={translations}
                        key={permission.permissionCode}
                    />
                ))}
            </List>
        </>
    );
};
